import { Device } from "./device";
import { Pagination, SupportNetwork } from "./supportNetwork";
import {HeartBeat} from "./measurements"
export enum EllieCenterUserRole {
	ADMIN = 'admin',
	SUPERVISOR = 'supervisor',
	USER = 'user',
}

export enum ActivityStatus {
	AVAILABLE = 'available',
	BUSY = 'busy',
	OFF_LINE = 'off_line'
}

export interface EllieCenterUser {
	id?: string | null | undefined
	first_name: string
	last_name: string
	email: string
	role: EllieCenterUserRole
	password?: string
	address?: string
	birth_date?: number
	phone_number?: string
	last_login?: Date
	activity_status?: ActivityStatus
  company_client : string | null,
  iat?: number;
  exp?: number;
  version_code?:string;
}

export interface EllieCenterUserMayEdit {
	first_name: string
	last_name: string
	address?: string
	birth_date?: number
	phone_number?: string
	activity_status?: ActivityStatus
}

export interface SignInData {
	email: string | null
	password: string | null
}

export interface SignInDataGoogle {
  email: string | null
  id_token?: string | null
}

export interface IProviderParams {
	email: string | undefined | null;
	device_token: string | null;
}

export interface SignUpData {
	first_name: string | null
	last_name: string | null
	email: string | null
	anura_email: string | null
	shift: string | null
	password: string | null
  role: string | null
}
export interface CreateUserData {
	first_name: string | null
	last_name: string | null
	email: string | null
	country_code: string | null
	phone: string | null
	plan_type: string | null
  support_network_role: string | null
}

export enum Status {
	checking,
	authenticated,
	notAuthenticated,
}

export interface FormUser {
	timestamp: string ,
	firstName: string,
	lastName: string,
	birthDay: string,
	address: string,
	email: string,
	countryCode: string;
	areaCode: string;
	phoneNumber: string,
	companionName: string,
	companionLastName: string,
	companionEmail: string,
	countryCodeAC: string;
	areaCodeAC: string;
  companionPhone: string,
}

export interface User {
  id: string;
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  role?: string | null;
  password?: string | null;
  country?: string | null;
  country_2?: string | null;
  province?: string | null;
	device?: null,
  province_2?: string | null;
  city?: string | null;
  city_2?: string | null;
  address?: string | null;
  apartment_info?: string | null;
  address_2?: string | null;
  birth_date?: string| null;
	validate_code?: boolean
  support_network_id?: string | null;
  support_network_role?: string | null;
  health_system_affiliate_number?: string | null;
  health_system_plan?: string | null;
  health_system_data?: RawHealthSystem | null;
  device_token?: string | null;
  endpoint_arn?: string | null;
  phone_number?: PhoneNumber | null;
  phone_number_landline?: PhoneNumber | null;
  phone_number_sw?: PhoneNumber | null;
  whatsapp?: PhoneNumber | null;
  first_login_complete?: boolean | null;
  last_login?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  deleted_at?: string | null;
  document_type?: string | null;
  document_number?: string | null;
  support_network?: SupportNetwork | null;
  cc_user_id?: string;
  role_id?: string;
}

export interface UserWithRole {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
  role_id: string;
  company_client: string;
  company_client_id?: string;
  password?: string | null;
}

export interface UserWithRolePagination {
  users: UserWithRole[];
  pagination: Pagination;
}

export interface QueryParamsUserRole {
  first_name?: string;
  last_name?: string;
  email?: string;
  role?: string
  company_client?: string;
  page?: number;
  limit?: number;
}

export interface BOUser {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
	country?: string;
	province?: string;
	city?: string;
  address?: string;
	apartment_info?:string;
  address_2?: null | string;
  birth_date?: null | string ;
  support_network_id?: string;
  support_network_role?: string;
  health_system?: null | string;
  phone_number?: PhoneNumber
	phone_number_landline?: PhoneNumber
	phone_number_sw?: PhoneNumber
	whatsapp?: PhoneNumber
  last_login?: string;
  activity_status?: string;
  created_at?: string;
  updated_at?: string;
  deleted_at?: null | string;
  supportNetwork?: SupportNetwork;
  device?: Device;
}

export interface BatteryUser {
  user: BOUser;
	lastMeasurement: HeartBeat;
	updated_at: string;
	agentFullName: string;
}
export interface RawHealthSystem {
	id?: string | null;
	name: string | null
	address: string | null
	email: string | null
	emergency_phone_number: string | null
	contact_phone_number: string | null
	busness_name: string | null
	tax_identification_code: string | null
	contact_persons: null,

}

export interface PhoneNumber {
	country_code?: string,
	number?: string | number
}

export const EmptyUser = {
  id: '',
  first_name: '',
  last_name: '',
  email: '',
  role: '',
  address: '',
  city: '',
  province: '',
  country: '',
  birth_date: '',
  support_network_id: '',
  support_network_role: '',
  health_system_affiliate_number: '',
  health_system_plan: '',
  phone_number: {
    country_code: '',
    number: '',
  },
  phone_number_sw: {
    country_code: '',
    number: '',
  },
  document_type: '',
  document_number: '',
  apartment_info: '',
	profiles:[]
};

export const EmptyHealthSystem = {
  id: '',
  name: '',
	emergency_phone_number: '',
	contact_phone_number: '',
  address: '',
	email: ''
};

export const COUNTRY_CODE = [
  { id: 1, country_code: "+54", display: "(+54)" },
  { id: 2, country_code: "+598", display: "(+598)" },
  { id: 3, country_code: "+52", display: "(+52)" },
  { id: 4, country_code: "+56", display: "(+56)" },
  { id: 5, country_code: "+51", display: "(+51)" },
  { id: 6, country_code: "+55", display: "(+55)" },
  { id: 7, country_code: "+57", display: "(+57)" },
  { id: 8, country_code: "+506", display: "(+506)" },
];

export const COUNTRY_NAME = [
  { id: 1, conuntry_name: 'Argentina', display: "Argentina" },
  { id: 2, conuntry_name: 'Uruguay',  display: "Uruguay" },
  { id: 3, conuntry_name: 'Mexico', display: "Mexico" },
  { id: 4, conuntry_name: 'Chile', display: "Chile" },
  { id: 5, conuntry_name: 'Perú', display: "Perú" },
  { id: 6, conuntry_name: 'Brasil', display: "Brasil" },
  { id: 7, conuntry_name: 'Colombia', display: "Colombia" },
  { id: 8, conuntry_name: 'Costa Rica', display: "Costa Rica" },
];

export const DOCUMENT_TYPE = [
  {id: 1, document_type: 'DNI', display: 'DNI'},
  {id: 2, document_type: 'CI', display: 'CI'},
  {id: 3, document_type: 'CUIL', display: 'CUIL'},
  {id: 4, document_type: 'CUIT', display: 'CUIT'},
  {id: 5, document_type: 'PASAPORTE', display: 'PASAPORTE'}
]